export const MONTH_QUARTER_DELTA = 1
export const TOTAL_MONTH_IN_QUARTER = 3

export const QUARTER_INITIAL_MONTHS = [0, 3, 6, 9]

export const START_RANGE_DATE_POSITION = 0
export const END_RANGE_DATE_POSITION = 1
export const NOT_INDEX_CALENDAR_FOUND = -1

export const WITHOUT_DEFINED_RANGES = ""
export const START_INPUT_LABEL_ID =
	"phronesis.rangecalendar.range.start.input.label"
export const END_INPUT_LABEL_ID =
	"phronesis.rangecalendar.range.end.input.label"

export const BLANK_SPACE = "phronesis.blank.space"

export const WEEK_PRESET_ID = "WEEK_PRESET"
export const MONTH_PRESET_ID = "MONTH_PRESET"
export const QUARTER_PRESET_ID = "QUARTER_PRESET"
export const SEMESTER_PRESET_ID = "SEMESTER_PRESET"
export const YEAR_PRESET_ID = "YEAR_PRESET"
export const MOBILE_YEAR_PRESET_ID = "MOBILE_YEAR_PRESET"
export const CURRENT_QUARTER_VS_LAST_YEAR = "QUARTER_CURRENT_VS_LAST_YEAR"
export const MOBILE_QUARTER_VS_LAST_YEAR = "QUARTER_MOBILE_VS_LAST_YEAR"
export const MONTH_DATE_VS_LAST_YEAR = "MONTH_DATE_VS_LAST_YEAR"
export const MOBILE_MONTH_VS_LAST_YEAR = "MONTH_MOBILE_VS_LAST_YEAR"
export const LAST_90_DAYS_PRESET_ID = "LAST_90_DAYS_PRESET_ID"
export const LAST_30_DAYS_PRESET_ID = "LAST_30_DAYS_PRESET"
export const CUSTOM_RANGES_ID = "CUSTOM_RANGES"

export const MIN_YEAR_CALENDAR_SELECTOR = 2015
export const RANGE_STEP = 1
export const YEAR_OFFSET = 1
export const MIN_YEAR_OFFSET = 2

export const DATA_DELAY_IN_DAYS = 3
export const CLEAR_PERIOD_BUTTONS_FEATURE_FLAG = "clearPeriod"
